module.exports = __webpack_public_path__ + "img/cancel.3d34aeec.png";